export enum ComponentWrapperWidthEnum {
  default = '',
  fullWidth = 'is-full-width',
  absoluteFullWidth = 'is-absolute-full-width',
  smallWidth = 'is-small-width'
}
